// extracted by mini-css-extract-plugin
module.exports = {"title":"services-module--title--PCaoJ","wrapper":"services-module--wrapper--1DOfZ","item":"services-module--item--17qg_"};